import React from 'react';
import PropTypes from 'prop-types';
import { Translate as Trans } from 'react-i18nify';

// interpolation:
//      recommendation: The maximum file size is %{max_file_size}
//
//      <Translate id="recommendation" max_file_size="10MB" />
//
// plurals:
//      questions: "%{count} questions"
//      questions_1: 1 question
//
//      <Translate id="questions" count="30" />
//
// with fallback message
//      <Translate id="questions" count="30">30 questions</Translate>

const Translate = ({ id, children: fallbackMessage, ...rest }) => (
  <Trans value={id} fallbackMessage={fallbackMessage} {...rest} />
);

Translate.propTypes = {
  id: PropTypes.string.isRequired, // translation key
  children: PropTypes.node,
};

Translate.defaultProps = {
  children: null,
};

export default Translate;
